import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router';
import * as PatientsActions from '../../../actions/admin/patients_actions';
import * as FacilitiesActions from '../../../actions/facilities_actions';
import * as UserActions1 from '../../../actions/settingScreen_actions';
import * as UserActions2 from '../../../actions/admin/patients_actions';
import { bindActionCreators } from 'redux';
import { ModalDialogCommon } from '../../modal_dialog_common';
import { validate } from '../../../validations';
import Header from '../../../components/header';
import { RestPwdDialog } from '../../../components/reset_pwd_dialog';
let editscreenIdentifier = 'editStaff';
let viewscreenIdentifier = 'viewDetails';
import _ from 'lodash';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import InputMask from 'react-input-mask';
import * as UserActions from '../../../actions/user_actions';
import { cutom_utils } from '../../../ucd_utils/util';
import * as SettingScreen from '../../../actions/settingScreen_actions';

export var EditStaff = React.createClass({
    getInitialState() {
        return {
            isUpdateStaffMemeberSuccess: null,
            okModalMessage: null,

            // Mobile css
            mobileCssClass: "inputText",

            // Acivation Deactivation
            isActivation: false,
            activeStatus: "",
            isdeactive: null,
            // Password
            resetpwd: false,
            resetpwdClicked: false,
            resetPasswordResponseError: null,
            isSubmitEnabled: null,
            isEditMode: null,

            isActiveDeactiveSubmitted: null,
            isActiveDeactiveResponseSuccess: null, // Activation/Deactivation response
            activeDeactiveModalMsg: null,
        }
    },

    componentWillMount() {
        var facility_id = this.props.UserDetails.selectdUserFacilityID;

    },

    componentWillReceiveProps(nextProps) {
        // Reset Password
        if (this.state.resetpwdClicked) {
            this.setState({ resetpwdClicked: false });
            if (nextProps.Setting.Changepassword && nextProps.Setting.Changepassword.status === 200) {
                this.setState({ resetpwd: false, okModalMessage: nextProps.Setting.Changepassword.message });
            }
            else {
                this.setState({ resetPasswordResponseError: nextProps.Setting.Changepassword.message });
            }
        }

        // Activation/Deactivation
        if (this.state.isActiveDeactiveSubmitted) {
            this.setState({ isActiveDeactiveSubmitted: null });

            if (nextProps.Setting.StaffStatus && nextProps.Setting.StaffStatus.status == 200) {
                nextProps.FacilitiesDetails.FaciliteAdminUser = null;
                this.props.Dispatch(FacilitiesActions.getAdminUserById(this.props.UserDetails.currentStaffMember.user.id + "/" + this.props.UserDetails.selectdUserFacilityID));

                this.setState({ isActiveDeactiveResponseSuccess: true });
                this.setState({ okModalMessage: nextProps.Setting.StaffStatus.message, isUpdateStaffMemeberSuccess: null });
                nextProps.Setting.StaffStatus = null;
            }
            else {
                this.setState({ isActiveDeactiveResponseSuccess: null });
            }
        }

        // Staff Update Success
        if (this.state.isSubmitEnabled) {
            this.setState({ isSubmitEnabled: null });
            if (nextProps.Setting.profileUpdate && nextProps.Setting.profileUpdate.status == 200) {
                this.setState({ isEditMode: null });

                this.setState({ okModalMessage: nextProps.Setting.profileUpdate.message, isUpdateStaffMemeberSuccess: true });
                let facilitiesID = this.props.UserDetails.selectdUserFacilityID;
                //  this.props.Dispatch(UserActions2.getAllStaffData(facilitiesID));
            }
            else if (nextProps.Setting.profileUpdate && nextProps.Setting.profileUpdate.status != 200) {
                this.setState({ okModalMessage: nextProps.Setting.profileUpdate.message, isUpdateStaffMemeberSuccess: null });
            }
        }


        // if (nextProps.FacilitiesDetails.FaciliteAdminUser) {
        //     //this.props.Dispatch(UserActions.setCurrentStaffMember(nextProps.FacilitiesDetails.FaciliteAdminUser.data));
        //     nextProps.FacilitiesDetails.FaciliteAdminUser = null;
        // }
    },

    componentDidMount() {

    },

    email_validate(event) {
        let email = event.target.value;
        let isValidEmail = validate.email(email);
        isValidEmail ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    phon_validate(event) {
        let mobile = event.target.value;
        let isValidMobile = validate.phone(mobile);
        isValidMobile ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    no_empty(event) {
        let value = event.target.value;
        let isEmptyValue = validate.notEmpty(value);
        isEmptyValue ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    selectionChanged(event) {
        event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom';
        this.setState({ isSubmitEnabled: true });
        this.setState({ isEditMode: true });
    },

    closebox() {
        // this.setState({ showAddStaffSuccessModal: false, adminerr: false, showFailureModel: false });
        this.setState({ activeDeactiveModalMsg: null, okModalMessage: null, isActivation: false, resetpwd: false, resetPasswordResponseError: null });
        // if (this.state.isUpdateStaffMemeberSuccess) {
        //     this.props.router.push('/admin/staff');
        // }

        if (this.state.isActiveDeactiveResponseSuccess) {
            this.setState({ isActiveDeactiveResponseSuccess: null });
            this.props.router.goBack();
        }
    },

    remove_error(event) {
        event.target.type === "text" ? event.target.className = 'inputText' : event.target.className = '';
    },
    enableSubmit() {
        this.setState({ isSubmitEnabled: true });
        this.setState({ isEditMode: true });
    },
    updateStaffMemberInfo() {
        // To make the fields editable
        if (!this.state.isEditMode) {
            this.setState({ isEditMode: true });
            return;
        }
        if (this.state.isEditMode && !this.state.isSubmitEnabled) {
            this.setState({ okModalMessage: "Please update any field to save." });
            return;
        }
        this.setState({ okModalMessage: null });
        var facility_id = this.props.UserDetails.selectdUserFacilityID;
        let firstName = this.refs.firstName.value.trim(),
            lastName = this.refs.lastName.value.trim(),
            mobile = this.refs.mobile.state.value.replace(/ /g, ""),
            dobYear = this.refs.dobYear.value.trim(),
            facilityRoleId = this.refs.designation.value.trim(),
            gender = this.refs.gender.value.trim();
        let isValidMobile = validate.phone(mobile);

        !firstName.length ? this.refs.firstName.className = "inputText error" : this.refs.firstName.className = "inputText";
        !lastName.length ? this.refs.lastName.className = "inputText error" : this.refs.lastName.className = "inputText";
        !dobYear.length ? this.refs.dobYear.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom' : this.refs.dobYear.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label';
        !facilityRoleId.length ? this.refs.designation.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom' : this.refs.designation.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label';
        !gender.length ? this.refs.gender.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom' : this.refs.gender.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label';
        !isValidMobile ? this.setState({ mobileCssClass: 'inputText error' }) : this.setState({ mobileCssClass: 'inputText' });

        if (dobYear.length === 0 || firstName.length === 0 || lastName.length === 0 || mobile.length === 0 || facilityRoleId.length === 0 || gender.length === 0) {
            this.setState({ okModalMessage: "Please enter necessary fields to proceed." });
            return false;
        }
        if (dobYear.length && firstName.length && lastName.length && mobile.length && isValidMobile && facilityRoleId.length && gender.length) {

            var data = {
                "id": this.props.UserDetails.currentStaffMember.user.id,
                "uniqueKey": this.props.UserDetails.currentStaffMember.user.uniqueKey,
                "firstName": firstName,
                "lastName": lastName,
                "mobile": mobile,
                "yearOfDob": dobYear,
                "createdBy": { "id": this.props.UserDetails.loginData.data.id, role: { "id": this.props.UserDetails.selectedUserRoleID } },
                "facility": { "id": facility_id },
                "role": { "id": 8 },
                "facilityRole": { "id": facilityRoleId },
                "gender": gender,
            }

            this.props.Dispatch(UserActions1.profileUpdate(data));
        }
        else {
            this.setState({ okModalMessage: "Please enter necessary fields to proceed." });
        }
    },
    cancel() { this.props.router.goBack(); },

    ToglePrevilizedUser(e) {
        if (e.target.value != "true") {
            this.setState({ previlizedUser: false });
        }
        else {
            this.setState({ previlizedUser: true });
        }
    },

    // Active/Deactive staff member
    deactivatePatient(event) {

        let activeStatus = event.target.dataset.isactive;
        let patient_id = event.target.dataset.patient_id;
        let p_uq = event.target.dataset.uq;
        let msg = activeStatus == "1" ? "Are you sure you want to activate this account?" : "Are you sure you want to deactivate this account?";
        let isdeactive = activeStatus === "1" ? false : true;
        this.setState({ isActivation: true, activeStatus: activeStatus, patient_id: patient_id, activeDeactiveModalMsg: msg, p_uq: p_uq, isDeactive: isdeactive });

    },
    deactivatePatientYes() {

        let data = {};
        let activeStatus = this.state.activeStatus;
        data.uniqueKey = this.state.p_uq;
        data.id = this.state.patient_id;
        data.facilityId = this.props.UserDetails.selectdUserFacilityID;
        data.isDeactive = this.state.isDeactive; //true ---> true if accept false if reject
        this.setState({ isActiveDeactiveSubmitted: true });
        this.props.Dispatch(SettingScreen.updateStaffSatus(data));
        this.setState({ isActivation: false });

    },

    // Reset Password
    resetPwdModal() { this.setState({ 'resetpwd': true }) },
    resetPassword(obj) {

        var data = {};
        var new_pwd = obj.refs.new_pwd.value.trim();
        var password = obj.refs.re_pwd.value.trim();
        if (new_pwd != password) {
            return false;
        }

        data.id = this.props.UserDetails.currentStaffMember.user.id;
        data.uniqueKey = this.props.UserDetails.currentStaffMember.user.uniqueKey;
        data.password = password;
        data.isPasswordChange = obj.refs.isPasswordChange.checked;
        this.setState({ resetpwdClicked: true });
        this.props.Dispatch(SettingScreen.changePassword(data));
    },
    removeResetPasswordResponseError() {
        this.setState({ resetPasswordResponseError: null });
    },
    render() {
        var getYrs = cutom_utils.getYears();
        var yearOptions = getYrs.map(function (years) {
            return <option key={years}
                value={years}>{years}</option>;
        });
        var isDisabled = null;

        return (
            <div className="dashboard-inner-content">

                <div className="row">
                    <div className="col-sm-12 no-padding">

                        <div className="admin-details-buttons edit-staff-buttons pull-right">

                            {(this.props.UserDetails.currentStaffMember.status === "APPROVE" || this.props.UserDetails.currentStaffMember.status === "DEACTIVATED") &&
                                <button className="edit gray-button" onClick={this.deactivatePatient} data-isactive={this.props.UserDetails.currentStaffMember.status === "APPROVE" ? 0 : 1} data-uq={this.props.UserDetails.currentStaffMember.user.uniqueKey} data-patient_id={this.props.UserDetails.currentStaffMember.user.id} > {this.props.UserDetails.currentStaffMember.status === "APPROVE" ? "DEACTIVATE" : "ACTIVATE"}</button>}

                            {this.props.UserDetails.currentStaffMember.status === "APPROVE" && <button className="change gray-button" onClick={this.resetPwdModal} >Reset Password</button>}
                        </div>
                    </div>

                </div>
                {this.props.UserDetails.currentStaffMember.status === "APPROVE" ?
                    <Header screenIdentifier={editscreenIdentifier} breadcrumb={true} /> : <Header screenIdentifier={viewscreenIdentifier} breadcrumb={true} />
                }
                <div className="breadcrumb-custom">
                    <h2> <Link to="/admin/staff">STAFF</Link> >  <a>{this.props.UserDetails.currentStaffMember.status === "APPROVE" ? "Edit" : "VIEW"}</a> -{this.props.UserDetails.currentStaffMember.user.firstName} </h2>
                </div>
                <div className="white-box">
                    <div className="recovery-facility">
                        <h4>{this.props.UserDetails.currentStaffMember.status === "APPROVE" ? "EDIT STAFF" : "VIEW DETAILS"}</h4>
                        <div className={this.props.UserDetails.currentStaffMember.status === "APPROVE" ? "row" : "row no-pointer-event"} >
                            <div className="col-xs-6 no-padding staff-recovery">
                                <div className="row">
                                    <div className="col-xs-6 padding-right-20">
                                        <div className="input-group">
                                            <input type="text" className="inputText" tabIndex={this.props.UserDetails.currentStaffMember.status === "APPROVE" ? "1" : "-1"} ref="firstName" onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} maxLength="64" defaultValue={this.props.UserDetails.currentStaffMember.user.firstName} required />
                                            <span className="floating-label">First Name</span>
                                        </div>
                                    </div>
                                    <div className="col-xs-6 no-padding">
                                        <div className="input-group">
                                            <input type="text" className="inputText" tabIndex={this.props.UserDetails.currentStaffMember.status === "APPROVE" ? "2" : "-1"} ref="lastName" onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} maxLength="64" defaultValue={this.props.UserDetails.currentStaffMember.user.lastName} required />
                                            <span className="floating-label">Last Name</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 no-padding">
                                        <div className="input-group readonly">
                                            <input type="text" className="inputText" tabIndex="-1" ref="email" defaultValue={this.props.UserDetails.currentStaffMember.user.email} required />
                                            <span className="floating-label">Email</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-6 no-padding padding-right-20">
                                        <div className="input-group">
                                            <InputMask type="text" className={this.state.mobileCssClass} tabIndex={this.props.UserDetails.currentStaffMember.user.status === "APPROVE" ? "3" : "-1"} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.phon_validate} ref="mobile" required mask="999 999 9999" maskChar={null} defaultValue={this.props.UserDetails.currentStaffMember.user.mobile} required></InputMask>
                                            <span className="floating-label">Phone</span>
                                        </div>
                                    </div>
                                    <div className="col-xs-6 no-padding">
                                        <div className="aj-dropdown with-label">
                                            <label>Year of Birth</label>
                                            <div className="source">
                                                <div className="question-selection">
                                                    <select ref="dobYear" onChange={this.selectionChanged} tabIndex={this.props.UserDetails.currentStaffMember.status === "APPROVE" ? "4" : "-1"} defaultValue={this.props.UserDetails.currentStaffMember.user.yearOfDob} onFocus={this.selectionChanged} onBlur={this.selectionChanged} required>
                                                        <option value="" default>Year of Birth</option>
                                                        {yearOptions}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-6 no-padding padding-right-20">
                                        <div className="aj-dropdown with-label">
                                            <label>Professional Role</label>
                                            <div className="source">
                                                <div className="question-selection">

                                                    <select ref="designation" onChange={this.selectionChanged} tabIndex={this.props.UserDetails.currentStaffMember.status === "APPROVE" ? "5" : "-1"} defaultValue={this.props.UserDetails.currentStaffMember.facilityRole ? this.props.UserDetails.currentStaffMember.facilityRole.id : ""} onFocus={this.selectionChanged} onBlur={this.selectionChanged} required>
                                                        {/* <option value="" default>Designation</option>
                                                        <option value="3" >Psychiatrist Support Staff</option>
                                                        <option value="4" >Therapist</option>
                                                        <option value="5" >Other Support Staff</option>
                                                        <option value="6" >Administrative Staff</option> */}
                                                        <option value="" default> Professional Role </option>
                                                        {/* <option value="3" >Psychiatrist Support Staff</option>
                                                            <option value="4" >Therapist</option> */}
                                                        {/* <option value="6" >Administrative Staff</option> */}
                                                        <option value="9" >Clinician/Therapist</option>
                                                        <option value="10" >Prescriber/Psychiatrist/Other Medical Personnel</option>
                                                        <option value="11" >Clinical Supervisor/Team Lead</option>
                                                        <option value="12" >Clinic Coordinator</option>
                                                        <option value="13" >Administrative Support Staff</option>
                                                        <option value="14" >Family Advocate</option>
                                                        <option value="15" >Peer Support Specialist</option>
                                                        <option value="16" >Case Manager/Recovery Coach</option>
                                                        <option value="17" >Supported Education & Employment Specialist</option>
                                                        <option value="18" >Program Director</option>
                                                        <option value="19" >Research Staff/Site Coordinator</option>
                                                        <option value="20" >Other</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-6 no-padding">
                                        <div className="aj-dropdown with-label">
                                            <label>Gender</label>
                                            <div className="source">
                                                <div className="question-selection">
                                                    <select ref="gender" onChange={this.selectionChanged} tabIndex={this.props.UserDetails.currentStaffMember.status === "APPROVE" ? "6" : "-1"} defaultValue={this.props.UserDetails.currentStaffMember.user.gender} onFocus={this.selectionChanged} onBlur={this.selectionChanged} required>
                                                        <option value="">Gender</option>
                                                        <option value="MALE">Male</option>
                                                        <option value="FEMALE">Female</option>
                                                        <option value="OTHER">Other</option>
                                                        <option value="NA">Don’t want to specify</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 no-padding recovery-buttons">
                            {this.props.UserDetails.currentStaffMember.status === "APPROVE" && <button className="gray-button" onClick={this.updateStaffMemberInfo}>{this.state.isEditMode ? "SAVE" : "EDIT"}</button>}
                            <button className="white-button" onClick={this.cancel} >Back</button>
                        </div>
                    </div>
                </div>
                {this.state.okModalMessage && <ModalDialogCommon message={this.state.okModalMessage} action={this.closebox} />}

                {this.state.isActivation && <ModalDialogCommon message={this.state.activeDeactiveModalMsg} cancel="true" action2={this.closebox} action={this.deactivatePatientYes} />}
                {this.state.resetpwd && <RestPwdDialog confirm={this.resetPassword} cancel={this.closebox} errorMessage={this.state.resetPasswordResponseError} removeErrorMessage={this.removeResetPasswordResponseError} />}
            </div>

        );
    }
});


let mapStateToProps = (state) => {
    return {
        PatientsDetails: state.Patients,
        UserDetails: state.User,
        Setting: state.Setting,
        FacilitiesDetails: state.Facilites

    };
};

let mapDispatchToProps = (dispatch) => ({
    UserActions: bindActionCreators(UserActions, dispatch),
    PatientsActions: bindActionCreators(PatientsActions, dispatch),
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(EditStaff));



/** WEBPACK FOOTER **
 ** ./src/components/admin/staff/editStaff.js
 **/